/*
* Association inventory detail photo gallery view for authenticated users
*/

import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import Lightbox from 'react-images';
import ReactImageFallback from 'react-image-fallback';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import { Formatters } from '../common/formatters';

export interface IInventoryPhotoGalleryProps {
    clearLinkCaption?: any;
    heading?: any;
    images?: any;
    onClearLinkClick?: any;
    onSelectLinkClick?: any;
    preventScroll?: any;
    selectLinkCaption?: any;
    showThumbnails?: any;
    subheading?: any;
    theme?: any;
}
export interface IInventoryPhotoGalleryState {
    lightboxIsOpen?: any;
    currentImage?: any;
}

export default class InventoryPhotoGallery extends React.Component<IInventoryPhotoGalleryProps, IInventoryPhotoGalleryState> {
    public static propTypes = {
        clearLinkCaption: PropTypes.string,
        heading: PropTypes.string,
        images: PropTypes.array,
        onClearLinkClick: PropTypes.func,
        onSelectLinkClick: PropTypes.func,
        preventScroll: PropTypes.bool,
        selectLinkCaption: PropTypes.string,
        showThumbnails: PropTypes.bool,
        subheading: PropTypes.string,
        theme: PropTypes.object,
    };

    public static defaultProps = {
        clearLinkCaption: 'Clear',
        heading: '',
        images: [],
        onClearLinkClick: (e: any, obj: any) => { return; },
        onSelectLinkClick: (e: any, obj: any) => { return; },
        preventScroll: false,
        selectLinkCaption: 'Select',
        showThumbnails: true,
        subheading: '',
        theme: {
            container: {
                background: 'rgba(10,10,10,0.9)',
            },
            footer: {
                color: 'white',
                className: 'test',
                class: 'test2',
            },
            footerCount: {
                color: 'white',
            },
            thumbnail__active: {
                boxShadow: '0 0 0 2px #337ab7',
            },
        },
    };

    public constructor(props: IInventoryPhotoGalleryProps) {
        super(props);

        this.state = {
            lightboxIsOpen: false,
            currentImage: 0,
        };
    }

    public openLightbox(index: number, event: any) {
        event.preventDefault();

        this.setState({
            currentImage: index,
            lightboxIsOpen: true,
        });
    }

    public closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    public gotoPrevious() {
        this.setState({
            currentImage: Math.min(this.state.currentImage - 1, 0)
        });
    }

    public gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    public gotoImage(index: number) {
        this.setState({
            currentImage: index,
        });
    }

    public handleClickImage() {
        if (this.state.currentImage === this.props.images.length - 1) {
            return;
        }

        this.gotoNext();
    }

    public renderGallery() {
        const { images } = this.props;

        if (!images) { return; }

        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };
        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { /* console.log(`onchange`, { n, v }); */ },
            className: 'inventory-detail-input-full-width',
        });

        const OTooltip = ({ tText, tId, ...rest }) => {
            const t = (<Tooltip id={tId}>{tText}</Tooltip>);

            return (
                <OverlayTrigger placement="top" overlay={t}>
                    {rest.children}
                </OverlayTrigger>
            );
        };

        const gallery = images.map((imageObj, i) => {
            // console.log(`map images`, imageObj);
            const imgTitle = Formatters.getStr(imageObj, 'title');
            return (
                <div key={i} className="association-inventory-detail-picture-block text-center">
                    <div className="association-inventory-detail-picture-label gallery-rendergallery-picture-label-wrapper">
                        <OTooltip tText={imgTitle} tId={`tooltip-${i}`} key={`tooltip-wrapper-${i}`}>
                            <p className="truncate">{imgTitle}</p>
                        </OTooltip>
                    </div>

                    <div className="center-block">
                        <a href={imageObj.src} className="gallery-thumbnail" onClick={(e) => this.openLightbox(i, e)}>
                            <ReactImageFallback
                                src={imageObj.thumbnail}
                                fallbackImage={imageObj.thumbnailFallback}
                                className="gallery-source img-responsive img-rounded"
                            />
                        </a>
                    </div>

                    <div className="text-center">
                        <a href="#" onClick={e => { this.props.onSelectLinkClick(e, imageObj); }} className="association-inventory-detail-picture-link">{this.props.selectLinkCaption}</a>
                        {(!imageObj.emptyPath) ? (
                            <a href="#" onClick={e => { this.props.onClearLinkClick(e, imageObj); }} className="association-inventory-detail-picture-link">{this.props.clearLinkCaption}</a>
                        ) : undefined}
                    </div>
                </div>
            );
        });

        return (
            <div className="gallery-wrapper">{gallery}</div>
        );
    }

    public render() {
        return (
            <div className="gallery-section">
                {this.props.heading && <h2>{this.props.heading}</h2>}
                {this.props.subheading && <p>{this.props.subheading}</p>}
                {this.renderGallery()}

                <Lightbox
                    currentImage={this.state.currentImage}
                    images={this.props.images}
                    isOpen={this.state.lightboxIsOpen}
                    onClickImage={e => { this.handleClickImage(); }}
                    onClickNext={e => { this.gotoNext(); }}
                    onClickPrev={e => { this.gotoPrevious(); }}
                    onClickThumbnail={e => { this.gotoImage(e); }}
                    onClose={e => { this.closeLightbox(); }}
                    preventScroll={this.props.preventScroll}
                    showThumbnails={this.props.showThumbnails}
                    theme={this.props.theme}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/inventory/gallery.tsx